import storePropColor from "./store/modules/store.propColor";

<template>
  <div id="app" :class="{ variluxXrBackground: isVariluxXrSeries }">
    <router-view />
    <ModalCgu :hasFullService="hasFullService" v-show="!cgu && cguLoaded" @close="acceptCgu()"
      @openCGU="isCguContentDisplay = true" />
    <ModalContentCgu v-if="isCguContentDisplay" @close="isCguContentDisplay = false" />
  </div>
</template>

<script lang="javascript">
import rangeStore from '@Store/modules/store.range.js';
import quizzStore from '@Store/modules/store.quizz.js';
import webControlStore from '@Store/modules/store.webControl.js';
import visonCategory from '@Store/modules/store.UnderstandVideo.js';
import storeMedia from '@Store/modules/store.media.js';
import storeProduct from '@Store/modules/store.product.js';
import storeTint from '@Store/modules/store.tint.js';
import storePropColor from '@Store/modules/store.propColor.js';
import Api from './services/Api.js';
import ModalCgu from './components/Menus/ModalCgu';
import ModalContentCgu from './components/Menus/ModalContentCgu';
import Vue from 'vue'
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip'

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
export default {
  watch: {
    $route() {
      if (window.sessionStorage.getItem('storeId')) {
        this.$gtm.trackEvent({
          event_label: window.sessionStorage.getItem('storeId'),
          value: window.sessionStorage.getItem('storeId'),
        });
      }

      // handle frame background and styling for this specific product
      if (this.$route.path && this.$route.path.match(/^\/demos\/[0-9]+\//i)) {
        this.isVariluxXrSeries = (this.$store.getters.getProductSelected["correct"] === "VARILUX-XR-SERIES");
      } else {
        this.isVariluxXrSeries = false;
      }

    },
  },
  components: { ModalContentCgu, ModalCgu },
  created: function () {
    Api.initAxios();

    this.$store.registerModule('rangeStore', rangeStore);
    this.$store.registerModule('quizzStore', quizzStore);
    this.$store.registerModule('webControlStore', webControlStore);
    this.$store.registerModule('visonCategory', visonCategory);
    this.$store.registerModule('mediaStore', storeMedia);
    this.$store.registerModule('productStore', storeProduct);
    this.$store.registerModule('tintStore', storeTint);
    this.$store.registerModule('storePropColor', storePropColor);
    this.$store.dispatch('resetState');
    this.$store.subscribe(() => {
      if (this.$route.name !== 'Callback') {
        this.cguLoaded = true;
      }
    });
  },
  beforeDestroy: function () {
    this.$store.unregisterModule('rangeStore');
    this.$store.unregisterModule('quizzStore');
    this.$store.unregisterModule('webControlStore');
    this.$store.unregisterModule('visonCategory');
    this.$store.unregisterModule('mediaStore');
    this.$store.unregisterModule('productStore');
    this.$store.unregisterModule('tintStore');
  },
  mounted() {
    this.$store.watch(
      (state, getters) => getters.userIsSet,
      (newValue) => {
        if (newValue) this.loadStore();
      }
    );
    /**
     * ! for local development
     * ! - comment if statement & use this.loadStore() either way
     */
    if (window.sessionStorage.getItem('storeId')) {
      this.loadStore();
    }
  },
  beforeMount() { },
  data: () => {
    return {
      hasFullService: false,
      cgu: true,
      cguLoaded: false,
      isCguContentDisplay: false,
      isVariluxXrSeries: false,
    };
  },
  methods: {
    syncCguState() {
      const splitPath = this.$route.fullPath.split('/');
      if (this.$route.query.embed === 'true' && splitPath.length >= 2 && splitPath[1] === 'demos') {
        this.cgu = true;
        return;
      }
      this.hasFullService = window.sessionStorage.getItem('hasFullService') === 'true';
      this.cgu = !!window.sessionStorage.getItem('cgu');
    },
    loadStore() {
      this.$store.dispatch('loadProducts').then(applied => {
        if (applied) this.syncCguState();
      });
      this.$store.dispatch('loadValues');
      this.$store.dispatch('loadVideoLinks');
      this.$store.dispatch('loadMedias');
      this.$store.dispatch('loadProductsEssilor');
    },
    acceptCgu() {
      this.$store.dispatch('acceptCgu').then(() => {
        this.syncCguState();
      });
    },
  },
};
</script>

<style>
@keyframes anim-overflow {
  0% {
    opacity: 0;
    max-height: 0;
    overflow-y: hidden;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 1;
    max-height: 999px;
    overflow-y: auto;
  }
}

@keyframes anim-opacity {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

/* REGULAR */
@supports not (-ms-high-contrast: none) {

  /* Non-IE styles */
  @font-face {
    font-family: 'HurmeGeometricSans1';
    src: url(fonts/HurmeGeometricSans1-Regular.otf) format('truetype');
    font-display: swap;
  }
}

@font-face {
  /* Convert font: https://transfonter.org/ */
  font-family: 'HurmeGeometricSans1';
  src: url(fonts/HurmeGeometricSans1-Regular.ttf) format('truetype');
  font-display: swap;
}

/* BOLD */
@supports not (-ms-high-contrast: none) {

  /* Non-IE styles */
  @font-face {
    font-family: 'HurmeGeometricSans1';
    font-weight: 500;
    src: url(fonts/HurmeGeometricSans1-SemiBold.otf) format('truetype');
    font-display: swap;
  }
}

@font-face {
  /* Convert font: https://transfonter.org/ */
  font-family: 'HurmeGeometricSans1';
  src: url(fonts/HurmeGeometricSans1-SemiBold.ttf) format('truetype');
  font-weight: 500;
  font-display: swap;
}

/* LIGHT */
@supports not (-ms-high-contrast: none) {

  /* Non-IE styles */
  @font-face {
    font-family: 'HurmeGeometricSans1';
    font-weight: 300;
    src: url(fonts/HurmeGeometricSans1-Light.otf) format('truetype');
    font-display: swap;
  }
}

@font-face {
  /* Convert font: https://transfonter.org/ */
  font-family: 'HurmeGeometricSans1';
  src: url(fonts/HurmeGeometricSans1-Light.ttf) format('truetype');
  font-weight: 300;
  font-display: swap;
}

@font-face {
  font-family: 'HurmeGeometricSans1Light';
  font-weight: normal;
  src: url(fonts/HurmeGeometricSans1-Light.otf) format('truetype');
  font-display: swap;
}

#app {
  font-family: 'HurmeGeometricSans1', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: 7vw;
  padding-right: 7vw;
  padding-top: 11vh;
  padding-bottom: 11vh;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

html {
  height: 100%;
  font-family: HurmeGeometricSans1;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;
}

body {
  margin: 0;
  width: 100%;
  height: 100%;
}

@supports (-moz-appearance: none) {

  h1,
  h2,
  h3,
  h4 {
    font-weight: 500;
  }
}

h1,
h2,
h3,
h4 {
  margin: 0;
}

h3 {
  font-weight: 100;
}

h2 {
  text-transform: uppercase;
  font-size: 35px;
}

.back:hover {
  border: 1px solid black;
}

.variluxXrBackground {
  background-image: url(assets/background/frame-background-VARILUX-XR-SERIES.png);
  background-repeat: no-repeat;
  background-size: cover;
}

.variluxXrBackground .situation-label {
  color: white;
}

.variluxXrBackground .helpButton {
  color: white;
}

.variluxXrBackground .homeButton img {
  filter: invert(1);
}

.variluxXrBackground .helpButton img {
  filter: invert(1);
}

.variluxXrBackground .component__select {
  background-color: transparent !important;
}

.variluxXrBackground .component__select .component__select--name {
  background-color: transparent !important;
}

.variluxXrBackground .component__select .component__select--name>img {
  filter: invert(96%) sepia(100%) saturate(0%) hue-rotate(120deg) brightness(103%) contrast(106%);
}

.variluxXrBackground .component__select h4 {
  color: white !important;
}

.variluxXrBackground .component__select .category {
  color: white !important;
}

.variluxXrBackground .component__select .name {
  color: white !important;
}

.variluxXrBackground .select-video h4,
.variluxXrBackground .select-video-compared h4,
.variluxXrBackground .select-video .name,
.variluxXrBackground .select-video-compared .name,
.variluxXrBackground .select-video-name {
  color: white !important;
}

.variluxXrBackground .select-video-compared img.logo-xr,
.variluxXrBackground .select-video-compared img.image-size:not(.logo-ofg):not(.img-white) {
  filter: invert(96%) sepia(100%) saturate(0%) hue-rotate(120deg) brightness(103%) contrast(106%);
}

.variluxXrBackground .logo-bottom-right {
  filter: invert(96%) sepia(100%) saturate(0%) hue-rotate(120deg) brightness(103%) contrast(106%);
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: white;
  color: black;
  border-radius: 3px;
  padding: 5px 10px 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: white;
  z-index: 1;
}

.tooltip{
  margin-bottom: 10px;
}

.tooltip .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: white;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

@media (max-width: 1280px) {

  /* #app {
      padding-right: 120px;
      padding-left: 120px;
      padding-top: 11%;
      padding-bottom: 19%;
    } */
  h2 {
    text-transform: uppercase;
    font-size: 20px;
  }
}

@media (max-width: 1440px) and (min-width: 1025px) {
  #app {
    padding-left: 6vw;
    padding-right: 6vw;
    padding-top: 9vh;
    padding-bottom: 9vh;
  }
}

@media (max-width: 1024px) {
  #app {
    padding-left: 5vw;
    padding-right: 5vw;
    padding-top: 8vh;
    padding-bottom: 8vh;
  }
}

/* 1920x1080 at 150% scale => CSS viewport ~1280x720 */
@media screen and (max-width: 1400px) and (max-height: 800px) {
  h2 {
    font-size: 16px;
  }
}
</style>
